import type { DataSet } from "@incytestudios/ddv";
import type { PressureTraverseChartContext } from "./d";

export const getPressureTraverseDataset = (
  context: PressureTraverseChartContext
): DataSet => {
  const {
    targetPressureUnit,
    targetLargeLengthUnit,
    bottomTubingPressurePSIA,
    requiredDischargePressurePSIA,
    completePumpDepthFt,
    pumpIntakePressurePSIA,
    wellFlowingPressureAtPerfsPSIA,
    topOfPerforationsMeasuredDepthFeet
  } = context;
  return {
    title: "Pressure",
    points: [
      {
        x: targetPressureUnit.toThisUnit(bottomTubingPressurePSIA || 0),
        y: 0
      },
      {
        x: targetPressureUnit.toThisUnit(requiredDischargePressurePSIA || 0),
        y: targetLargeLengthUnit.toThisUnit(completePumpDepthFt || 0)
      },
      {
        x: targetPressureUnit.toThisUnit(pumpIntakePressurePSIA || 0),
        y: targetLargeLengthUnit.toThisUnit(completePumpDepthFt || 0)
      },
      {
        x: targetPressureUnit.toThisUnit(wellFlowingPressureAtPerfsPSIA || 0),
        y: targetLargeLengthUnit.toThisUnit(
          topOfPerforationsMeasuredDepthFeet || 0
        )
      }
    ],
    xAxisLabel: `Pressure (${
      targetPressureUnit?.shortLabel || targetPressureUnit.label
    })`,
    yAxisLabel: `Depth (${
      targetLargeLengthUnit?.shortLabel || targetLargeLengthUnit.label
    })`,
    reverseYAxis: true
  };
};
